var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:_vm.b(),attrs:{"color":"error","type":"error","value":true,"outlined":""}},[_c('div',{class:_vm.b('text')},[_vm._v(_vm._s(_vm.message))]),_c('v-btn',{attrs:{"color":"error","type":"button"},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v("Reintentar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }